import { UserX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CardSkeleton } from './CardSkeleton';

interface AbsentUsersCardProps {
  absentUsers: number;
  changeText: string;
  isLoading?: boolean;
}

export const AbsentUsersCard: React.FC<AbsentUsersCardProps> = ({ absentUsers, changeText, isLoading }) => {
  const { t } = useTranslation('dashboard');

  if (isLoading) {
    return <CardSkeleton />;
  }

  return (
    <div className="bg-card p-6 rounded-lg border shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium">{t('cards.absentUsers.title')}</h3>
        <UserX className="w-5 h-5 text-muted-foreground" />
      </div>
      <div className="text-2xl font-bold mb-2">{absentUsers}</div>
      <div className="text-sm text-muted-foreground">{changeText}</div>
    </div>
  );
};
